import {Component, Inject, OnInit} from '@angular/core';
import {LogErroModel} from './log-erro-model';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Processamento} from '../processamento/processamento';
import {LogErroService} from './log-erro.service';
import {Subject, Subscription} from "rxjs";
import {indicate, ToastService} from "maps-angular-components";
import {BrowserSupport} from "../../shared/util/browser-support";

@Component({
  selector: 'app-log-erro',
  templateUrl: './log-erro.component.html',
  styleUrls: ['./log-erro.component.scss']
})
export class LogErroComponent implements OnInit {

  logErroModel: LogErroModel;

  processamento: Processamento;

  loadingExport$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private messageService: ToastService,
    private logErroService: LogErroService,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) { }

  ngOnInit(): void {
    this.processamento = this.data;
    this.logErroService.search(this.processamento.carteiraId).subscribe(
      data => {
        this.logErroModel = data;
      },
      error => {
        console.log(error);
      }
    );
  }

  exportarTxt() {
    this.logErroService.exportTxt(this.processamento.carteiraId, this.processamento)
      .pipe(indicate(this.loadingExport$))
      .subscribe(
        (response) => {
          BrowserSupport.saveTextFile(response);
          this.messageService.sucesso('Exportação realizada com sucesso.');
        },
        e => {
          this.messageService.erro(`${e}`)
        }
      );
  }

}
